var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;}")),React.createElement("path",{"className":"cls-1","d":"M29.2,31.66a2.49,2.49,0,0,1-1.77-.73L16,19.5,4.57,30.93A2.5,2.5,0,0,1,1,27.39l13.2-13.2a2.52,2.52,0,0,1,3.54,0L31,27.39a2.52,2.52,0,0,1,0,3.54A2.49,2.49,0,0,1,29.2,31.66Z","key":1}),React.createElement("path",{"className":"cls-1","d":"M16,18.54a2.53,2.53,0,0,1-1.77-.73L1,4.61A2.5,2.5,0,0,1,4.57,1.07L16,12.5,27.43,1.07A2.5,2.5,0,0,1,31,4.61l-13.2,13.2A2.53,2.53,0,0,1,16,18.54Z","key":2})]);
}

IconClose.defaultProps = {"id":"圖層_1","data-name":"圖層 1","viewBox":"0 0 32 32"};

module.exports = IconClose;

IconClose.default = IconClose;
